import { RETURN_SHAPE } from '@/lib/return-to'
import { oneOf, readSearch } from '@/lib/search-params'

/** Les cinq étapes de l'éditeur d'un brouillon, portées par l'URL (`etape`). */
export const QUOTE_STEPS = ['generalites', 'produits', 'rabais', 'conditions', 'envoi'] as const
export type QuoteStep = (typeof QUOTE_STEPS)[number]

export const QUOTE_STEP_LABELS: Record<QuoteStep, string> = {
  generalites: 'Généralités',
  produits: 'Produits',
  rabais: 'Rabais',
  conditions: 'Conditions et notes',
  envoi: 'Confirmation et envoi',
}

const SHAPE = { etape: oneOf(QUOTE_STEPS), ...RETURN_SHAPE }

export interface QuoteStepSearch {
  etape?: QuoteStep | undefined
  retour?: string | undefined
}

export function parseQuoteStepSearch(search: Record<string, unknown>): QuoteStepSearch {
  return readSearch(SHAPE, search)
}

/** Champs du formulaire qui vivent à chaque étape : pour renvoyer à la première en erreur. */
export const QUOTE_STEP_FIELDS: Record<QuoteStep, readonly string[]> = {
  generalites: ['title', 'opportunity_id', 'valid_until', 'intro'],
  produits: ['lines'],
  rabais: ['lines'],
  conditions: ['notes', 'sale_types'],
  envoi: [],
}
